import { Fragment, PropsWithChildren } from "react";
import { Link, LinkProps, useMatches } from "remix";

export function BreadcrumbLink(props: LinkProps) {
  return (
    <Link
      className="text-sm text-slate-600 mr-2 hover:text-slate-700 hover:underline last:pointer-events-none last:text-slate-500"
      {...props}
    />
  );
}
export function BreadcrumbSeparator() {
  return <span className="text-sm text-slate-400 mr-2">{"/"}</span>;
}

export function BreadcrumbsWrapper({ children }: PropsWithChildren<{}>) {
  return (
    <nav
      data-breadcrumbs
      className="mt-5 flex flex-wrap items-center justify-start"
    >
      {children}
    </nav>
  );
}

export function Breadcrumbs() {
  const matches = useMatches();
  const breadcrumbs = matches
    // skip routes that don't have a breadcrumb
    .filter((match) => match.handle && match.handle.breadcrumb);
  const forceHideBreadcrumps = matches.some(
    (match) => match.handle && match.handle.hideBreadcrumbs === true
  );

  if (forceHideBreadcrumps) {
    return null;
  }

  return (
    <div className="main-layout-centered">
      <BreadcrumbsWrapper>
        <BreadcrumbLink to="/">WWSU</BreadcrumbLink>
        {!!breadcrumbs.length &&
          breadcrumbs.map((match, index) => (
            <Fragment key={index}>
              <BreadcrumbSeparator />
              {match.handle.breadcrumb(match)}
            </Fragment>
          ))}
      </BreadcrumbsWrapper>
    </div>
  );
}
